import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RequireAuth } from "../Utils/RequireAuth";
import { useAuth } from "../Utils/Auth";
import Welcome from "../Component/DashBoard/Welcome";
import ErrorPage from "../pages/ErrorPage";
import Login from "../Component/Login/Login";
import AdminLayout from "../Component/Sidebar/AdminLayout";
import AdminList from "../Component/SuperAdmin/AdminList";
import AdminEditrole from "../Component/SuperAdmin/AdminEditrole";
// import CreateIntroducer from "../Component/DashBoard/CreateIntroducer";
import IntroducerProfile from "../Component/DashBoard/IntroducerProfile";
// import UserProfile from "../Component/DashBoard/UserProfile";
import MainTransactionPage from "../pages/TransactionPage/MainTransactionPage";
import Alert from "../Component/DashBoard/Alert";
import IntroducerAlert from "../Component/IntroducerAlert";
import BankDelete from "../Component/DashBoard/Request/Bank/BankDelete";
import BankEdit from "../Component/DashBoard/Request/Bank/BankEdit";
import NewBank from "../NewBank&Website/NewBank";
import NewWebsite from "../NewBank&Website/NewWebsite";
import WebsiteEdit from "../Component/DashBoard/Request/Website/WebsiteEdit";
import WebsiteDelete from "../Component/DashBoard/Request/Website/WebsiteDelete";
import TrashAllTransaction from "../Component/TrashAllTransaction";
import IntroducerStatement from "../Component/DashBoard/IntroducerStatement";
import BankTransactionPage from "../pages/TransactionPage/BankTransactionPage";
import WebsiteTransactionPage from "../pages/TransactionPage/WebsiteTransactionPage";
import InnerIntroducer from "../Component/DashBoard/InnerIntroducer";
import CreateTransaction from "../Component/DashBoard/CreateTransaction";
import InnerUserProfile from "../Component/DashBoard/InnerUserProfile";
import SingleIntroducer from "../Component/DashBoard/SingleIntroducer";
import EditProfileSubadmin from "../Component/SuperAdmin/EditProfileSubadmin";
import IntroShowPr from "../Component/DashBoard/IntroShowPr";
import TransactionDetails from "../Component/DashBoard/TransactionDetails";
import EditTransaction from "../Component/Modal/EditTransaction";
import EditWebTransaction from "../Component/DashBoard/EditWebTransaction";
import EditBnkTransaction from "../Component/DashBoard/EditBnkTransaction ";
import EditBank from "../Component/EditBank";
import ResetPassword from "../Component/DashBoard/ResetPassword";
// import BankStatement from "../Component/DashBoard/BankStatement";
import MainFilterTransaction from "../pages/TransactionPage/MainFilterTransaction";
// import Transaction from "../Component/transaction";
import DepositTransaction from "../ui/transaction/deposit";
import WithdrawTransaction from "../ui/transaction/withdraw";
import BankView from "../ui/bank";
import Website from "../ui/website";
import WebsiteTransactionView from "../ui/website/transactionView";
import BankTransactionView from "../ui/bank/transactionView";
// import CreateAdmin from "../Component/DashBoard/CreateUser"
import CreateUser from "../ui/create/user/index"
import CreateIntroducer from '../ui/create/introducer/index'
import CreateAdmin from '../ui/create/admin/index'
import BankToBankTransfer from "../ui/transaction/bank_to_bank_transfer";
import AllTransaction from "../ui/report/allTransaction";
import MyTransaction from "../ui/report/myTransaction";
import BankRequests from "../ui/request/bankRequests";
import BankToBankTransferRequests from '../ui/transaction/bank_to_bank_transfer_request'
import WebsiteRequests from "../ui/request/websiteRequests";
import IntroducerTransactionRequests from '../ui/request/introducerTransaction'
import AllTransactionRequests from "../ui/request/allTransaction";
import UserProfile from "../ui/profile/user";
import AdminProfile from "../ui/profile/admin";
import UserTransaction from "../ui/profile/user/transaction";
import IntroducerTransaction from "../ui/profile/introducer/transaction";
import UserStatement from "../ui/profile/user/statement";

const AppRoutes = () => {
  const userrole = sessionStorage.getItem("role") || "";

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Login />} />
        <Route path="*" element={<ErrorPage />} />
        <Route path="/" element={<AdminLayout />}>
          <Route
            path="welcome"
            element={
              <RequireAuth>
                <Welcome />
              </RequireAuth>
            }
          />
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") ||
              role.includes("Withdraw")
          ) && (
            <Route
              path="withdraw"
              element={
                <RequireAuth>
                  <WithdrawTransaction/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") ||
              role.includes("Deposit")
          ) && (
            <Route
              path="deposit"
              element={
                <RequireAuth>
                <DepositTransaction/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") ||
              role.includes("Bank-Transfer")
          ) && (
              <Route
                path="bank_To_bankTransfer"
                element={
                  <RequireAuth>
                    <BankToBankTransfer />
                  </RequireAuth>
                }
              />
            )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") ||
              role.includes("Bank-Transfer-Request")
          ) && (
              <Route
                path="bank_To_bank_transfer_request"
                element={
                  <RequireAuth>
                    <BankToBankTransferRequests />
                  </RequireAuth>
                }
              />
            )}

          {[userrole]?.some(
            (role) => role.includes("superAdmin") || role.includes("Bank-Page-View")
          ) && (
            <Route
              path="bank"
              element={
                <RequireAuth>
                  <BankView/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("Website-Page-View")
          ) && (
            <Route
              path="website"
              element={
                <RequireAuth>
                  <Website/>
                </RequireAuth>
              }
            />
          )}

          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("Create-User")
          ) && (
            <Route
              path="createactualuser"
              element={
                <RequireAuth>
                  {/* <CreateActualUser /> */}
                <CreateUser/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("Create-Introducer")
          ) && (
            <Route
              path="createintroducer"
              element={
                <RequireAuth>
                  {/* <CreateIntroducer /> */}
                  <CreateIntroducer/>
                </RequireAuth>
              }
            />
          )}

          {[userrole]?.some((role) => role.includes("superAdmin")) && (
            <Route
              path="createuser"
              element={
                <RequireAuth>
                  {/* <CreateAdmin/> */}
                  <CreateAdmin />
                </RequireAuth>
              }
            />
          )}

          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") ||
              role.includes("User-Profile-View")
          ) && (
            <Route
              path="userprofile"
              element={
                <RequireAuth>
                  {/* <UserProfile /> */}
                  <UserProfile/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") ||
              role.includes("Introducer-Profile-View")
          ) && (
            <Route
              path="introducerprofile"
              element={
                <RequireAuth>
                  <IntroducerProfile />
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some((role) => role.includes("superAdmin")) && (
            <Route
              path="adminlist"
              element={
                <RequireAuth>
                  {/* <AdminList /> */}
                  <AdminProfile/>
                </RequireAuth>
              }
            />
          )}
          {/* {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("All-Transaction-Report")
          ) && (
            <Route
              path="maintransactionpage"
              element={
                <RequireAuth>
                  <MainTransactionPage />
                </RequireAuth>
              }
            />
          )} */}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("All-Transaction-Report")
          ) && (
            <Route
              path="mainfiltertransactionpage"
              element={
                <RequireAuth>
                  {/* <MainTransactionPage /> */}
                  <AllTransaction/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("My-Transaction-Report")
          ) && (
            <Route
              path="mytxn"
              element={
                <RequireAuth>
                  {/* <MyTxn /> */}
                  <MyTransaction/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("All-Transaction-Request")
          ) && (
            <Route
              path="allTransactionRequest"
              element={
                <RequireAuth>
                  {/* <Alert /> */}
                  <AllTransactionRequests/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("Introducer-Transaction-Request")
          ) && (
            <Route
              path="introduceralert"
              element={
                <RequireAuth>
                  {/* <IntroducerAlert /> */}
                  <IntroducerTransactionRequests/>
                </RequireAuth>
              }
            />
          )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("Bank-Requests")
          ) && (
              <Route
                path="bankRequests"
                element={
                  <RequireAuth>
                    <BankRequests />
                  </RequireAuth>
                }
              />
            )}
          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("Website-Requests")
          ) && (
             <Route
              path="websiteRequests"
              element={
                <RequireAuth>
                <WebsiteRequests/>
                </RequireAuth>
              }
            />
          )}

          {[userrole]?.some(
            (role) =>
              role.includes("superAdmin") || role.includes("Recycle-Bin-View")
          ) && (
            <Route
              path="trashAllTransaction"
              element={
                <RequireAuth>
                  <TrashAllTransaction />
                </RequireAuth>
              }
            />
          )}
          


          <Route
            path="subadminedit/:id"
            element={
              <RequireAuth>
                <AdminEditrole />
              </RequireAuth>
            }
          />

          <Route
            path="introducerstatement/:id"
            element={
              <RequireAuth>
                {/* <IntroducerStatement /> */}
                <IntroducerTransaction/>
              </RequireAuth>
            }
          />
          <Route
            path="websitestatement/:id"
            element={
              <RequireAuth>
                {/* <WebsiteStatement /> */}
                <WebsiteTransactionView/>
              </RequireAuth>
            }
          />

          <Route
            path="bankstatement/:id"
            element={
              <RequireAuth>
                {/* <BankStatement/> */}
                <BankTransactionView/>
              </RequireAuth>
            }
          />
          <Route
            path="banktransactionpage/:id"
            element={
              <RequireAuth>
                <BankTransactionPage />
              </RequireAuth>
            }
          />
          <Route
            path="websitetransactionpage/:id"
            element={
              <RequireAuth>
                <WebsiteTransactionPage />
              </RequireAuth>
            }
          />
          <Route
            path="introducerprofile"
            element={
              <RequireAuth>
                <IntroducerProfile />
              </RequireAuth>
            }
          />
          <Route
            path="innerintroducer/:id"
            element={
              <RequireAuth>
                <InnerIntroducer />
              </RequireAuth>
            }
          />
          <Route
            path="dashboard"
            element={
              <RequireAuth>
                <CreateTransaction />
              </RequireAuth>
            }
          />

          <Route
            path="innerprofile"
            element={
              <RequireAuth>
                <InnerUserProfile />
              </RequireAuth>
            }
          />
          <Route
            path="singleintroducer/:id"
            element={
              <RequireAuth>
                <SingleIntroducer />
              </RequireAuth>
            }
          />
          <Route
            path="editsubadmin/:id"
            element={
              <RequireAuth>
                <EditProfileSubadmin />
              </RequireAuth>
            }
          />

          <Route
            path="showpercentageintroducer/:id"
            element={
              <RequireAuth>
                <IntroShowPr />
              </RequireAuth>
            }
          />
          <Route
            path="transactiondetails/:id"
            element={
              <RequireAuth>
                {/* <TransactionDetails /> */}
                <UserTransaction/>
              </RequireAuth>
            }
          />

           <Route
           path="userstatement/:id"
            element={
              <RequireAuth>
                {/* <UserStatement /> */}
                <UserStatement />
              </RequireAuth>
            }
          />

          <Route
            path="admindash/:id"
            element={
              <RequireAuth>
                <EditTransaction />
              </RequireAuth>
            }
          />

          <Route
            path="editwebsitedata/:id"
            element={
              <RequireAuth>
                <EditWebTransaction />
              </RequireAuth>
            }
          />
          <Route
            path="editbankdata/:id"
            element={
              <RequireAuth>
                <EditBnkTransaction />
              </RequireAuth>
            }
          />
          <Route
            path="editbank/:id"
            element={
              <RequireAuth>
                <EditBank />
              </RequireAuth>
            }
          />
          <Route
            path="websiteEdit"
            element={
              <RequireAuth>
                <WebsiteEdit />
              </RequireAuth>
            }
          />
          <Route
            path="bankEdit"
            element={
              <RequireAuth>
                <BankEdit />
               
              </RequireAuth>
            }
          />
          <Route
            path="resetpassword"
            element={
              <RequireAuth>
                <ResetPassword />
              </RequireAuth>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
